import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';

/**
 * Represents the data object used to configure and display a JSON modal dialog. See {@link JsonModal}.
 */
export class JsonModalDataObject {
  /** The name of the modal.  */
  name: string;

  /** The input data to be passed to the modal. Can be a single object or an array of objects implementing {@link ToJsonInputTranslatable}.  */
  input: ToJsonInputTranslatable | ToJsonInputTranslatable[];

  /** The text to be displayed in the header of the modal. */
  headerText: string;

  /** The text to be displayed on the submit button of the modal. */
  submitText: string;

  /** An optional array of field names to be skipped in the modal. */
  skipFields?: string[];

  /** An optional flag indicating whether the modal is read-only. */
  readOnly?: boolean;

  /** An optional flag indicating whether data we're working with is scoped. Will show scope selection if true. */
  isScoped?: boolean;

  /** An optional title for the subject of the modal. */
  subjectTitle?: string;

  /** An optional name for the subject of the modal. */
  subjectName?: string;

  /**
   * Constructs a new {@link JsonModalDataObject}.
   *
   * @param name - The name of the modal.
   * @param input - The input data to be passed to the modal. See {@link ToJsonInputTranslatable}.
   * @param headerText - The text to be displayed in the header of the modal.
   * @param submitText - The text to be displayed on the submit button of the modal.
   * @param skipFields - An optional array of field names to be skipped in the modal. Skipped fields will be added back to the JSON object before processing.
   * @param readOnly - An optional flag indicating whether the modal is read-only.
   * @param isScoped - An optional flag indicating whether the modal is scoped.
   * @param subjectTitle - An optional title for the subject of the modal.
   * @param subjectName - An optional name for the subject of the modal.
   */
  constructor(
    name: string,
    input: ToJsonInputTranslatable | ToJsonInputTranslatable[],
    headerText: string,
    submitText: string,
    skipFields?: string[],
    readOnly?: boolean,
    isScoped?: boolean,
    subjectTitle?: string,
    subjectName?: string
  ) {
    this.name = name;
    this.input = input;
    this.headerText = headerText;
    this.submitText = submitText;
    this.skipFields = skipFields;
    this.readOnly = readOnly;
    this.isScoped = isScoped;
    this.subjectTitle = subjectTitle;
    this.subjectName = subjectName;
  }
}
